/**
 * CRC-16/CCITT-FALSE (poly 0x1021, init 0xffff) over the code units of an
 * ASCII string. An error-detection checksum, not a security primitive.
 */
export const crc16 = (input) => {
    let crc = 0xffff;
    for (let i = 0; i < input.length; i++) {
        crc =
            ((crc << 8) ^
                CRC16_TABLE[((crc >> 8) ^ input.charCodeAt(i)) & 0xff]) &
                0xffff;
    }
    return crc;
};
const CRC16_TABLE = (() => {
    const table = new Uint16Array(256);
    for (let n = 0; n < 256; n++) {
        let crc = n << 8;
        for (let bit = 0; bit < 8; bit++) {
            crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : crc << 1;
        }
        table[n] = crc & 0xffff;
    }
    return table;
})();
